import { useState, useEffect, useRef } from 'react';
import './Stats.css';

const useCountUp = (end, duration = 2000, start = 0) => {
  const [count, setCount] = useState(start);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(easeOut * (end - start) + start));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [isVisible, end, start, duration]);

  return [count, ref];
};

const StatItem = ({ icon, end, suffix, label }) => {
  const [count, ref] = useCountUp(end);

  return (
    <div className="stat-item" ref={ref}>
      <div className="stat-icon">
        <i className={icon}></i>
      </div>
      <div className="stat-number">
        {count}{suffix}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

const Stats = () => {
  const stats = [
    { icon: 'fas fa-calendar-check', end: 500, suffix: '+', label: 'Eventos Realizados' },
    { icon: 'fas fa-award', end: 10, suffix: '+', label: 'Anos de Experiência' },
    { icon: 'fas fa-smile', end: 98, suffix: '%', label: 'Clientes Satisfeitos' },
    { icon: 'fas fa-building', end: 50, suffix: '+', label: 'Clientes Atendidos' },
  ];

  return (
    <section className="stats">
      <div className="stats__container">
        {stats.map((stat, index) => (
          <StatItem key={index} {...stat} />
        ))}
      </div>
    </section>
  );
};

export default Stats;
